import { DetailsList, IColumn, Link, MessageBar, MessageBarType, ProgressIndicator, SelectionMode } from '@fluentui/react';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { getKeplerSyllabus } from '../data/assignments';
import { humanFileSize, isCanvasTeacher, isCurrentUserAStudentOrTeacherInCourse } from '../lib/helper';
import { useAuthenticationContext } from '../providers/authenticationprovider';
import { HelperService } from '../services/helperService';
import { ICourse } from '../types/ICourse';
const Syllabus: React.FunctionComponent<{ courseProp: ICourse}> = ({ courseProp }) => {

  const authContext = useAuthenticationContext();
  const [keplerSyllabus, setKeplerSyllabus] = useState<any[]>();
  const [noCourseId, setNoCourseId] = useState<boolean>();
  const [error, setError] = useState<string | undefined>();
  const [loading, setLoading] = useState<boolean>(true);
  const [canvasHostUrl, setCanvasHostUrl] = useState<string | undefined>()

  React.useEffect(() => {
      try
      {
          HelperService.getKeplerEnvironmentVariable("REACT_APP_DEFAULT_CANVAS_HOST").then(canvasUrl => {
              setCanvasHostUrl(canvasUrl);
          });
      }
      catch(err)
      {
          console.log("Unable to get canvas host URL");
      }
  })

  useEffect(() => {
    if(courseProp.CanvasId)
    {
      getKeplerSyllabus(courseProp).then(files => {
        if(files.error)
        {
          console.log("Kepler Syllabus Load Error", files.error);
          setError("The Kepler Syllabus folder does not exist in Canvas");
        }
        else
        {
          setKeplerSyllabus(files);
        }
      }).catch(err => {
        console.log("Kepler Syllabus Load Error", err);
        setError("Unknown error occurred");
      }).finally(() => {
        setLoading(false);
      })
    }
    else
    {
      setNoCourseId(true);
      setLoading(false);
    }
  }, [courseProp])

  const columns: IColumn[] = [
    { 
      key: "display_name",
      name: "Name",
      fieldName: "display_name",
      minWidth: 300,
      onRender:(item) => {
        return <Link href={item.url}>{item.display_name}</Link>
      }
    },
    { 
      key: "updated_at",
      name: "Last Modified",
      fieldName: "updated_at",
      minWidth: 300,
      onRender:(item) => {
        return <span>{moment(item.updated_at).format("M/D/YYYY hh:mm a")}</span>
      }
    },
    { 
      key: "size",
      name: "Size",
      fieldName: "size",
      minWidth: 300,
      onRender:(item) => {
        return <span>{humanFileSize(item.size)}</span>
      }
    }
  ]

  const currentUseIsTeacherInCourse = authContext.Result && isCanvasTeacher(authContext.Result) && isCurrentUserAStudentOrTeacherInCourse(authContext.Result!, courseProp);

  return (
    <div className="home" style={{padding: 20}}>
      <h2 style={{fontWeight: "normal"}}>Syllabus - {courseProp.Title}</h2>      
      {loading && <ProgressIndicator />}
      {canvasHostUrl && currentUseIsTeacherInCourse && courseProp.CanvasId &&
          <div style={{padding: 10}}><Link target='_blank' href={`https://${canvasHostUrl}/courses/${courseProp.CanvasId}/files`}>Go to canvas to upload a syllabus file</Link></div>
      }
      {keplerSyllabus && <DetailsList columns={columns} items={keplerSyllabus} selectionMode={SelectionMode.none} />}
      {keplerSyllabus && keplerSyllabus.length === 0 && <div>No syllabus has been uploaded to Kepler</div>}
      {noCourseId && <div>Unable to get Canvas ID from stored course</div>} 
      {error && <MessageBar messageBarType={MessageBarType.info}>{error}</MessageBar>}
    </div>
  );
}

export default Syllabus;
